import ManagerState, { AccountData, ArticleData, KajikiData } from './state'

export function getActiveKajiki(state: ManagerState): KajikiData {
  if (!state.accountData) {
    throw new Error('認証前に呼び出せません')
  }
  const kajikiId = state.accountData.kajikiId
  const found = state.kajikiData.find(kajiki => kajiki.kajikiId === kajikiId)

  if (!found) {
    throw new Error('データに不整合があります。')
  }
  return found
}

export function kajikiList(state: ManagerState): KajikiData[] {
  return state.kajikiData
}

export function getAcountData(state: ManagerState): AccountData {
  if (!state.accountData) {
    throw new Error('認証前に呼び出せません')
  }
  return state.accountData
}

export function selectedArticles(state: ManagerState): ArticleData[] {
  return state.articles.filter(article => article.selected)
}

export function selectedArticleIds(state: ManagerState): number[] {
  return selectedArticles(state)
    .map(article => article.contentId)
    .reduce((list, contentId) => {
      if (contentId) {
        list.push(contentId)
      }
      return list
    }, [] as number[])
}

export function totalCount(state: ManagerState): number {
  return state.baseData.total
}

export function indexFrom(state: ManagerState): number {
  const start = state.baseData.start
  const total = totalCount(state)
  return (total > 0) ? start : 0
}

export function isLoadingKajiki(state: ManagerState): boolean {
  return state.loading.kajiki
}

export function isLoadingArticle(state: ManagerState): boolean {
  return state.loading.article
}

export function totalStorage(state: ManagerState): number {
  return state.storageData.storage.total
}

export function usedStorage(state: ManagerState): number {
  return state.storageData.storage.use
}

export function accountName(state: ManagerState): string {
  return state.accountData.accountName
}

export default {
  getActiveKajiki,
  kajikiList,
  getAcountData,
  selectedArticles,
  selectedArticleIds,
  totalCount,
  indexFrom,
  isLoadingKajiki,
  isLoadingArticle,
  totalStorage,
  usedStorage,
  accountName
}
